<div *ngIf="displayCard && enablePartnersOffersV2; else displayV1DynamicPartnersView">
  <div *ngIf="enableClaimOfferCTA; else defaultViewV2">
    <div
      class="partner-offer-item" [ngClass]="{'offer-claim-height': enableClaimOfferCTA, 'default-height': !enableClaimOfferCTA}">
      <div class="partners-offer-label" *ngIf="partnersOfferDisplay?.partnerOfferType === 'limited-time-offer'">
        <span class="p-2">Limited time offer</span>
      </div>
      <div id="image-description" class="sr-only">{{ partnersOfferDisplay?.bgImgAltText }}</div>
      <div class="partners-offer-img" role="img"
        [attr.aria-labelledby]="'image-description'"></div>
      <div class="partners-offer-content">
        <div class="partners-card-title-container">
          <h3 class="partners-card-title">{{ partnersOfferDisplay?.title}}</h3>
        </div>
        <div class="partners-card-sub-title-container">
          <div class="partners-card-sub-title">{{ partnersOfferDisplay?.subTitle}}</div>
        </div>
        <div class="offer-btn-container">
          <div  *ngIf="partnersOfferDisplay?.isOfferRedeemed; else showClaimOffers">
            <button class="pds-btn pds-btn-outlined--neutral offerClaimCTA" type="button" aria-label="Redeem offer for {{ partnersOfferDisplay?.title }}"
            [ngClass]="{'isDisabled': (partnersOfferDisplay?.isOfferRedeemed)}">
            <img alt="partners check-mark"src="ocsp-web-ui/dist/assets/images/check-mark.png" class="fp-partner-offers-check-mark" aria-hidden="true">
            <span aria-hidden="true">{{'Redeemed'}}</span>
          </button>
          </div>
          <ng-template #showClaimOffers>
            <button class="pds-btn pds-btn-outlined--neutral offerClaimCTA" type="button"  (click)="onClickCTA($event)" 
              (keydown.enter)="onClickCTA($event)" [ngClass]="{'isDisabled': !partnersOfferDisplay?.enableCta}"
              [attr.aria-label]="'Claim offer for ' + (partnersOfferDisplay?.title)">
              {{partnersOfferDisplay?.ctaText}}
          </button>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <ng-template #defaultViewV2>
    <div class="partner-offer-item" [ngClass]="{'offer-claim-height': enableClaimOfferCTA, 'default-height': !enableClaimOfferCTA}">
      <div class="partners-offer-label" *ngIf="partnersOfferDisplay?.partnerOfferType === 'limited-time-offer'">
        <span class="p-2">Limited time offer</span>
      </div>
      <div id="image-description" class="sr-only">{{ partnersOfferDisplay?.bgImgAltText }}</div>
      <div class="partners-offer-img" role="img"
        [attr.aria-labelledby]="'image-description'"></div>
      <div class="partners-offer-content">
        <div class="partners-card-title-container">
          <h3 class="partners-card-title">{{ partnersOfferDisplay?.title}}</h3>
        </div>
        <div class="partners-card-sub-title-container">
          <div class="partners-card-sub-title">{{ partnersOfferDisplay?.subTitle}}</div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<ng-template #displayV1DynamicPartnersView>
  <div *ngIf="enableClaimOfferCTA; else defaultViewV1">
    <div
      class="partner-offer-item" [ngClass]="{'offer-claim-height': enableClaimOfferCTA, 'default-height': !enableClaimOfferCTA}">
      <div id="image-description" class="sr-only">{{ partnersOfferDisplay?.bgImgAltText }}</div>
      <div class="partners-offer-img" role="img"
        [attr.aria-labelledby]="'image-description'"></div>
      <div class="partners-offer-content">
        <div class="partners-card-title-container">
          <h3 class="partners-card-title">{{ partnersOfferDisplay?.title}}</h3>
        </div>
        <div class="partners-card-sub-title-container">
          <div class="partners-card-sub-title">{{ partnersOfferDisplay?.subTitle}}</div>
        </div>
        <div class="offer-btn-container">
          <div  *ngIf="partnersOfferDisplay?.isOfferRedeemed; else showClaimOffers">

            <button class="pds-btn pds-btn-outlined--neutral offerClaimCTA" type="button" [attr.aria-label]="'Redeem offer for ' + (partnersOfferDisplay?.title)"
            [ngClass]="{'isDisabled': (partnersOfferDisplay?.isOfferRedeemed)}">
            <img alt="partners check-mark"src="ocsp-web-ui/dist/assets/images/check-mark.png" class="fp-partner-offers-check-mark" aria-hidden="true">
            <span aria-hidden="true">{{'Redeemed'}}</span>
          </button>
          </div>
          <ng-template #showClaimOffers>
            <button class="pds-btn pds-btn-outlined--neutral offerClaimCTA" type="button"  (click)="onClickCTA($event)"
              (keydown.enter)="onClickCTA($event)" [ngClass]="{'isDisabled': (!partnersOfferDisplay?.enableCta)}"
              [attr.aria-label]="'Claim offer for ' + (partnersOfferDisplay?.title)">
              {{partnersOfferDisplay?.ctaText}}
          </button>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <ng-template #defaultViewV1>
    <div class="partner-offer-item" [ngClass]="{'offer-claim-height': enableClaimOfferCTA, 'default-height': !enableClaimOfferCTA}">
      <div id="image-description" aria-hidden="true" class="sr-only">{{ partnersOfferDisplay?.bgImgAltText }}</div>
      <div class="partners-offer-img" role="img"
        [attr.aria-labelledby]="'image-description'"></div>
      <div class="partners-offer-content">
        <div class="partners-card-title-container">
          <h3 class="partners-card-title">{{ partnersOfferDisplay?.title}}</h3>
        </div>
        <div class="partners-card-sub-title-container">
          <div class="partners-card-sub-title">{{ partnersOfferDisplay?.subTitle}}</div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>